import { normalizeResolvedPath } from '../../paths/normalize-resolved-path.js';
import type { IsolatedWorktreeBinding } from '../isolated-worktree-binding.js';

export class PreviewWorktreeCache {
  private readonly repoCheckoutPaths = new Map<string, string[]>();
  private readonly parentPathByEnvironment = new Map<string, string>();

  remember(environmentId: string, binding: IsolatedWorktreeBinding): void {
    const paths = binding.repoCheckoutPaths.map((p) => normalizeResolvedPath(p));
    this.repoCheckoutPaths.set(environmentId, paths);
    this.parentPathByEnvironment.set(environmentId, normalizeResolvedPath(binding.parentPath));
  }

  clearEnvironment(environmentId: string): string[] | undefined {
    const paths = this.repoCheckoutPaths.get(environmentId);
    this.repoCheckoutPaths.delete(environmentId);
    this.parentPathByEnvironment.delete(environmentId);
    return paths;
  }

  getParentPath(environmentId: string): string | undefined {
    return this.parentPathByEnvironment.get(environmentId);
  }

  hasEnvironment(environmentId: string): boolean {
    return this.parentPathByEnvironment.has(environmentId);
  }

  getRepoCheckoutPaths(environmentId: string): string[] | undefined {
    const paths = this.repoCheckoutPaths.get(environmentId);
    return paths?.length ? [...paths] : undefined;
  }

  getRepoCheckoutPathsRef(environmentId: string): string[] | undefined {
    const paths = this.repoCheckoutPaths.get(environmentId);
    return paths?.length ? paths : undefined;
  }

  listEnvironmentIds(): string[] {
    return [...this.parentPathByEnvironment.keys()];
  }
}
